module.exports = __webpack_public_path__ + "static/media/Gilroy-Light-Italic.5a516a37.eot";